import '../scss/app.scss';

import $ from 'jquery';
import 'what-input';

import video from './components/video.js';
import mnav from './components/mnav.js';
import slider from './components/slider.js';
import masonry from './components/masonry.js';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
// window.jQuery = $;
// window.$ = $;

//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';


$(document).foundation();


document.addEventListener('DOMContentLoaded', () => {
    mnav.init();
    video.init();
    slider.init();
    masonry.init();
})